import {
  CssBaseline,
  LocalizationProvider,
  StyledEngineProvider,
  ThemeProvider,
  themes,
} from '@freighthub/silhouette-core'
import { de } from 'date-fns/locale'
import React from 'react'
import { isoLocale, useI18n } from 'utils/localisation'

interface SilhouetteProviderProps {
  children: React.ReactNode
}

export const SilhouetteProvider: React.FC<SilhouetteProviderProps> = ({ children }) => (
  // Inject Emotion before JSS to avoid CSS specificity issues, see https://mui.com/material-ui/migration/v5-style-changes/#%E2%9C%85-adjust-css-injection-order
  // this should be removed once we migrate to emotion completely
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={themes.base}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  </StyledEngineProvider>
)

export const SilhouetteLocalizationProvider: React.FC<SilhouetteProviderProps> = ({ children }) => {
  const { current } = useI18n()
  console.log('SilhouetteLocalizationProvider >> current locale', current)

  const locale = current === 'de' ? de : isoLocale
  return <LocalizationProvider locale={locale}>{children}</LocalizationProvider>
}
